import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import SlateViewer from './slate-viewer';
import '../assets/css/markdown-viewer.css';
var SeatableViewer = /*#__PURE__*/function (_React$Component) {
  _inherits(SeatableViewer, _React$Component);
  var _super = _createSuper(SeatableViewer);
  function SeatableViewer(props) {
    var _this;
    _classCallCheck(this, SeatableViewer);
    _this = _super.call(this, props);
    _this.updateValue = function (nodes) {
      var newValue = nodes ? JSON.parse(nodes) : '';
      _this.setState({
        value: newValue
      });
    };
    _this.state = {
      value: null
    };
    return _this;
  }
  _createClass(SeatableViewer, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.updateValue(this.props.markdownContent);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.markdownViewer = this;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.markdownContent !== nextProps.markdownContent) {
        this.updateValue(nextProps.markdownContent);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.markdownViewer = null;
    }
  }, {
    key: "render",
    value: function render() {
      var value = this.state.value;
      if (!value) return null;
      return /*#__PURE__*/React.createElement(SlateViewer, {
        value: value
      });
    }
  }]);
  return SeatableViewer;
}(React.Component);
SeatableViewer.defaultProps = {
  markdownContent: ''
};
export default SeatableViewer;